<template>
  <v-container fluid class="pa-0">
    <v-img
      :src="require('@/assets/banner.jpg')"
      style="background-color:#222831"
      max-height="400"
    >
      <v-row align="center" justify="center" class="mb-10 fill-height">
        <v-col cols="12" md="4" class="my-8">
          <v-img
            class="d-block mx-auto my-8"
            max-width="400"
            width="80%"
            :src="require('@/assets/logo-white.png')"
          />
          <h2 class="white--text text-center">
            Monitoring System & Analytics
          </h2>
        </v-col>
      </v-row>
    </v-img>
    <v-row align="center" justify="center" class="mb-8">
      <v-col cols="10" md="6" class="my-16">
        <h2 class="text-center grey--text text--darken-4">
          Monitoring System & Analytics (MONSTA)
        </h2>
        <v-divider class="divider-title" />
        <div class="my-12">
          <p class="body-1 grey--text text--darken-4">
            Monitoring System & Analytics (MONSTA) adalah sebuah platform yang
            dirancang untuk memantau dan menganalisia sebuah operasi secara
            real-time.
          </p>
          <p class="body-1 grey--text text--darken-4">
            Tujuannya adalah untuk memberikan pemahaman mendalam terhadap proses
            kinerja sebuah operasi dan big data.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" style="background-color:#EEEEEE;position:relative;">
      <v-col cols="10" md="6">
        <v-card elevation="6" class="mt-n16 rounded-lg">
          <v-card-title />
          <v-card-text>
            <h2 class="text-center grey--text text--darken-4">
              Aplikasi MONSTA
            </h2>
            <v-divider class="divider-title" />
            <div class="my-12">
              <p class="body-1 text-center grey--text text--darken-4">
                MONSTA mengintegrasikan fungsi monitoring dengan kemampuan
                analitik tingkat tinggi, memberikan pengguna kemampuan untuk
                mengambil keputusan yang lebih tajam berdasarkan data statis
                maupun dinamis yang dikumpulkan.
              </p>
            </div>
          </v-card-text>
        </v-card>
        <v-row class="my-6">
          <v-col cols="12" md="4">
            <v-card elevation="6" class="rounded-lg">
              <v-card-title />
              <v-card-text class="text-center">
                <v-img
                  class="d-block mx-auto mb-4"
                  width="70%"
                  max-width="88"
                  :src="require('@/assets/icons/unit-dark.svg')"
                />
                <h3 class="my-2">Realtime Geo Tagging</h3>
                <p class="caption my-2">
                  Peta Wilayah & Sebaran Satgas
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card elevation="6" class="rounded-lg">
              <v-card-title />
              <v-card-text class="text-center">
                <v-img
                  class="d-block mx-auto mb-4"
                  width="70%"
                  max-width="88"
                  :src="require('@/assets/icons/monitoring-dark.svg')"
                />
                <h3 class="my-2">Responsive Big Data</h3>
                <p class="caption my-2">
                  Laporan Digital Terarsip
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card elevation="6" class="rounded-lg">
              <v-card-title />
              <v-card-text class="text-center">
                <v-img
                  class="d-block mx-auto mb-4"
                  width="70%"
                  max-width="88"
                  :src="require('@/assets/icons/pengumuman-dark.svg')"
                />
                <h3 class="my-2">Analytic & Broadcast</h3>
                <p class="caption my-2">
                  Tren Kata Kunci, Analisa & Siaran
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-footer padless color="#222831" class="mt-6">
      <v-col class="text-center white--text" cols="12">
        {{ new Date().getFullYear() }} — <strong>MONSTA</strong>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
export default {};
</script>
<style scoped>
.divider-title {
  background-color: #7bc74d;
  height: 4px;
  max-height: 4px;
  max-width: 150px;
  display: block;
  margin: 16px auto;
}
#img-bg-satgas {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
